import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ChicagoPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: " What information do you need from me to start work?",
    answer: `<p>TekRevol, a leading <Link to='https://www.tekrevol.com/' rel='noopener' aria-label='TekRevol'>mobile app development company</Link>, consults the client to define the scope and expectations of their product and the timelines, deliverables, and challenges they would like to solve.</p>`,
  },
  {
    question: "How much does software development cost in Chicago?",
    answer: `<p>The average cost for software design and development depends on the type of project, its complexity, and other add-ons. If the project is complex then, it will cost higher than average cost.</p>`,
  },
  {
    question:
      "Should I be familiar with the technical details to start working with you?",
    answer: `<p>No, understanding all your project’s requirements and initiating the work is all on us. Our <Link to='https://www.tekrevol.com/android-app-development' rel='noopener' aria-label='TekRevol'>Android app development services</Link> handle all the technical work and keep you updated regarding all the development minutiae in all stages of the software development project.</p>`,
  },
  {
    question:
      "Do you provide product support services after the software development completion?",
    answer: `<p>Yes, we are happy to provide clients with after-sales and technical support for the application. The product support services include incorporating updates and third-party services for future versions and releases of your application.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{ChicagoPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
